module.exports = __webpack_public_path__ + "7bebe67e4da51cb9eb8753c7d3563d3a.png";